export default {
  school: 'المدرسه'
}
